import { render, staticRenderFns } from "./SupplementsSettings.vue?vue&type=template&id=66035af5&scoped=true"
import script from "./SupplementsSettings.vue?vue&type=script&lang=js"
export * from "./SupplementsSettings.vue?vue&type=script&lang=js"
import style0 from "./SupplementsSettings.vue?vue&type=style&index=0&id=66035af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66035af5",
  null
  
)

export default component.exports